import React from 'react';
import logoImg from '../../images/svg/bglobe-logo-white.svg';

/**
 * Site header.
 * @returns {React.component} The Header to render.
 */
export default function Header() {
  return (
    <header className="site-header">
      <a href={`${process.env.PUBLIC_URL}/`} title="The Boston Globe">
        <img src={logoImg} alt=""/>
      </a>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js